import PropTypes from 'prop-types'
import Modal from 'react-bootstrap/Modal'

import { SubirArchivo } from './SubirArchivos'
import styles from './Upload.module.css'

export const ModalUpload = ({
  show,
  onClose,
  idDoc,
  idPerfil,
  idTipo,
  onCarga,
  adjuntoPendiente
}) => {
  return (
    <Modal show={show} onHide={onClose} size={'lg'} animation={false}>
      <Modal.Header closeButton>
        <Modal.Title>
          <h3>Adjuntar archivo</h3>
        </Modal.Title>
      </Modal.Header>
      <div className={styles.modalBody}>
        <SubirArchivo
          idUsuario={idPerfil}
          idTipo={idTipo || '1'}
          idDoc={idDoc}
          onCarga={onCarga}
          adjuntoPendiente={adjuntoPendiente}
        />
      </div>
    </Modal>
  )
}

ModalUpload.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  idDoc: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  idPerfil: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  idTipo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onCarga: PropTypes.func,
  adjuntoPendiente: PropTypes.array
}
